// Centralized runtime config + startup validation.
//
// In production we MUST NOT silently fall back to localhost when VITE_API_URL is
// missing - a misconfigured Vercel build would otherwise talk to localhost and
// hang on every request with no error. main.tsx checks MISSING_API_URL and shows
// an explanatory screen instead of booting the app. The localhost fallback is
// kept for local dev only (import.meta.env.DEV).

const rawApiUrl = import.meta.env.VITE_API_URL

/** True when a production build was shipped without VITE_API_URL configured. */
export const MISSING_API_URL = !rawApiUrl && import.meta.env.PROD

const DEV_FALLBACK = 'http://localhost:3000/api/v1'

// In prod-without-config we leave this empty; main.tsx blocks the app from
// rendering, so it is never actually used to make a request.
export const API_BASE_URL = rawApiUrl || (import.meta.env.DEV ? DEV_FALLBACK : '')

/** Socket origin = API base without the /api/v1 suffix. */
export const SOCKET_URL = API_BASE_URL.replace(/\/api\/v1\/?$/, '')
